import { useElement } from './core/element.js';
const name = 's-table';
const props = {};
const style = `:host{display:inline-block;font-size:.875rem;overflow:auto;border:solid 1px var(--s-color-outline-variant, #bfc8cb);background:var(--s-color-surface-container-high, #f2f4f5);border-radius:4px;white-space:nowrap}.container{overflow:hidden;min-width:fit-content}slot{display:table;border-collapse:collapse;border:solid 1px transparent;box-sizing:border-box;position:relative;left:-1px;top:-1px;margin-bottom:-2px;min-width:calc(100% + 2px)}@media (pointer: fine){:host::-webkit-scrollbar{width:6px;height:6px;background:transparent}:host::-webkit-scrollbar-thumb{background:var(--s-color-outline-variant, #bfc8cb);border-radius:3px}@supports not selector(::-webkit-scrollbar){:host{scrollbar-color:var(--s-color-outline-variant, #bfc8cb) transparent}}}`
const template = `<div class="container" part="container"><slot></slot></div>`
export class Table extends useElement({ style, template, props, }) {
}
const theadName = 's-thead';
const theadProps = {};
const theadStyle = `:host{display:table-header-group;font-weight:600;color:var(--s-color-on-surface-variant, #3f484b)}`
const theadTemplate = `<slot></slot>`
export class Thead extends useElement({
    style: theadStyle,
    template: theadTemplate,
    props: theadProps
}) {
}
const tbodyName = 's-tbody';
const tbodyProps = {};
const tbodyStyle = `:host{display:table-row-group;color:var(--s-color-on-surface, #191c1d)}::slotted(s-tr:nth-child(odd)){background:var(--s-color-surface-container-highest, #ffffff)}`
const tbodyTemplate = `<slot></slot>`
export class Tbody extends useElement({
    style: tbodyStyle,
    template: tbodyTemplate,
    props: tbodyProps
}) {
}
const trName = 's-tr';
const trProps = {};
const trStyle = `:host{display:table-row}`
const trTemplate = `<slot></slot>`
export class Tr extends useElement({
    style: trStyle,
    template: trTemplate,
    props: trProps
}) {
}
const thName = 's-th';
const thProps = {};
const thStyle = `:host{display:table-cell;padding:16px;text-transform:capitalize;border:solid 1px var(--s-color-outline-variant, #bfc8cb)}`
const thTemplate = `<slot></slot>`
export class Th extends useElement({
    style: thStyle,
    template: thTemplate,
    props: thProps
}) {
}
const tdName = 's-td';
const tdProps = {};
const tdStyle = `:host{display:table-cell;user-select:text;padding:12px 16px;border:solid 1px var(--s-color-outline-variant, #bfc8cb)}`
const tdTemplate = `<slot></slot>`
export class Td extends useElement({
    style: tdStyle,
    template: tdTemplate,
    props: tdProps
}) {
}
Table.define(name);
Thead.define(theadName);
Tbody.define(tbodyName);
Tr.define(trName);
Th.define(thName);
Td.define(tdName);
